module.exports = __webpack_public_path__ + "img/map1.ae7b2848.png";